export const parseBlogStyle = (text) => {
    return text
        .split('\n')
        .filter(string => string != '')
        .map(string => {
        let headerSize = 0;
        if (string.includes('{H') || string.includes('{i') || string.includes('<h')) {
            if (string.includes('H1') || string.includes('h1')) {
                headerSize = 1;
            }
            else if (string.includes('H2') || string.includes('h2')) {
                headerSize = 2;
            }
            else if (string.includes('H3') || string.includes('h3')) {
                headerSize = 3;
            }
        }
        else {
            const stringAsArray = string.split('');
            for (let i = 0; i < stringAsArray.length; i++) {
                const letter = stringAsArray[i];
                if (letter === '#' || letter === '*')
                    headerSize += 1;
                if (letter !== '#')
                    break;
            }
        }
        return {
            headerSize,
            content: string.replaceAll('#', '').replaceAll('*', '').replace(/\{/g, '<').replace(/\}/g, '>')
        };
    });
};
